{
  "documentOrder": ["til"],
  "termsPurchase": {
    "uplift": {
      "terms": "<div><span>I have read, understood and electronically agree to the </span><i>Loan Agreement (and Disclosure Statement contained therein)</i>{{docName}}<span>. By clicking \"</span><span>{{btnLabel}}</span>\"<span>, I acknowledge that I have been provided with an express opportunity to accept or decline the Loan Agreement and to correct errors. <strong>I understand that continuing may affect my credit score.</strong></span></div>"
    },
    "flexpay": {
      "terms": "<div><span>I have read, understood and electronically agree to the </span><i>Loan Agreement (and Disclosure Statement contained therein)</i>{{docName}}<span>. By clicking \"</span><span>{{btnLabel}}</span>\"<span>, I acknowledge that I have been provided with an express opportunity to accept or decline the Loan Agreement and to correct errors. <strong>I understand that continuing may affect my credit score.</strong> I acknowledge that I have been provided with an express opportunity to accept or decline the Loan Agreement and to correct errors.</span></div>"
    }
  },
  "docName": {
    "ach": "<span> and the <i>Pre-Authorized Debit Agreement</i></span>",
    "dcd": "<span> and the <i>Payment Terms Agreement</i></span>",
    "default": ""
  },
  "submit": "I Agree and Continue"
}
